import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import * as actions from "../../../store/actions";

import "./index.css";
import { useInfiniteScroll } from "../../../utils/pagination";

import PaymentHistoryList from "./PaymentHistoryList";

const PaymentHistory = ({
  paymentHistory,
  getCustomerPaymentHistory,
  removeCustomerPaymentHistory,
  downloadInvoice,
}) => {
  const [page, setPage] = useState(0);

  const loader = useRef(null);

  useInfiniteScroll(loader, () => {
    setPage(page => page + 1);
  });

  useEffect(() => {
    page > 0 && paymentHistory?.hasMore && getCustomerPaymentHistory();
    // eslint-disable-next-line
  }, [page]);

  useEffect(() => {
    removeCustomerPaymentHistory();
    //eslint-disable-next-line
  }, []);

  return (
    <div>
      <p className="text-dark h5 mb-4 font-weight-bold">Payments History</p>
      <PaymentHistoryList
        payments={paymentHistory?.results}
        downloadInvoice={downloadInvoice}
      />
      <div ref={loader}></div>
    </div>
  );
};

const mapStoreToProps = ({ settings }) => ({
  paymentHistory: settings?.paymentHistory,
});

const mapDispatchToProps = dispatch => ({
  getCustomerPaymentHistory: () =>
    dispatch(actions.getCustomerPaymentHistory()),
  removeCustomerPaymentHistory: () =>
    dispatch(actions.removeCustomerPaymentHistory()),
  downloadInvoice: (id, cb) => dispatch(actions.downloadInvoice(id, cb)),
});

export default connect(mapStoreToProps, mapDispatchToProps)(PaymentHistory);
